export const getTextFields = (jobTypeData: any) => [
    {
        id: "job-type",
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "Enter Name",
        required: true,
        capitalizedFirst: true,
        value: jobTypeData?.name
    },
    {
        label: "Status",
        value: jobTypeData?.enabled === true ? 'Enabled' : 'Disabled',
        formField: false,
    },
  
];